import nanoid from 'nanoid';
import Model from '@newspaces/zero-base/Model';

class AccessVendor extends Model {
  static Permissions = {
    read: false,
    insert: false,
    edit: false,
    remove: false
  };
  static CollectionName = "accessVendors";
  static Fields = {
    identity: {
      type: String,
      max: 10,
      min: 10,
      required: true,
      default: () => nanoid(10),
      serialize: "insert",
      description: "The unique identity of this vendor"
    },
    status: {
      type: String,
      enum: ["active", "inactive", "blocked"],
      default: "active",
      description: "The status of this vendor, only active ones can push"
    },
    name: {
      type: String,
      required: true,
      description: "The legal name of this vendor"
    },
    publicKey: {
      type: String,
      description: "The public key for this vendor to verify his signatures"
    },
    // {[HardwareType]: Count}
    registeredDevices: {
      type: Object,
      default: () => ({})
    }
  };
  constructor(data) {
    super(AccessVendor.Fields, data);
  }
}
Model.declareModel(AccessVendor);

export { AccessVendor as default };
//# sourceMappingURL=AccessVendor.js.map
